<template>
  <section class="home">
    <header-background>
      <!--header slot content-->
      <!--  <router-link
        v-if="showRijnjaContent"
        to="/werken-bij-rijnja"
        class="pill-button-lg werken-bij-rijnja"
        >Werken bij Rijnja</router-link
      > -->
      <div
        id="home-wrapper"
        :class="{
          printstore: rootStore.currentSection === 'printstore'
        }"
      >
        <post-its class="post-its" v-if="$route.name === 'home'"></post-its>
        <home-intro-text v-if="showRijnjaContent"></home-intro-text>

        <globe-menu></globe-menu>
        <transition name="slide">
          <print-store-bottom-bar
            class="ps-product-bar"
            v-if="showBottomBarDelayed"
          ></print-store-bottom-bar>
        </transition>

        <router-view v-slot="{ Component }">
          <transition name="router-anim" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </header-background>
    <home-page v-if="showRijnjaContent"></home-page>
  </section>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin'
import PrintStorePopUp from '@/dialogs/PrintStorePopUp.vue'
import { getRandomPrintStoreProducts } from '@/features/printstore/PrintStoreApi'

import HeaderBackground from '@/components/HeaderBackground.vue'
import GlobeMenu from '@/features/globeMenu/GlobeMenu.vue'
import PostIts from '@/components/PostIts.vue'
import { selectFileStoreFiles } from '@/api/api.js'
import HomeIntroText from '../components/HomeIntroText.vue'
import HomePage from './pages/HomePage.vue'
import { EventBus, Events } from '@/eventbus/EventBus'
import PrintStoreBottomBar from '../components/PrintStoreBottomBar.vue'
import { mapStores } from 'pinia'

import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import { useFileListStore } from '@/stores/FileList.store'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE } from '@/stores/store'

export default {
  props: ['dialog'],
  components: {
    HeaderBackground,
    GlobeMenu,
    PostIts,
    HomeIntroText,
    HomePage,
    PrintStoreBottomBar
  },
  data() {
    return {
      showBottomBarDelayed: false
    }
  },
  mixins: [DialogMixin],
  computed: {
    ...mapStores(useFileListStore, useFileStoreStore),
    theme() {
      return this.rootStore.theme
    },
    showRijnjaContent() {
      return !!(this.$route.name === 'home' && this.theme.showRijnjaContent)
    },
    hasPrintStore() {
      return this.rootStore.interactions.some(
        (ia) => ia.destination === 'printStore'
      )
    },
    showBottomBar() {
      return this.theme.customFields.printStoreAd.showFooter &&
        this.$route.name === 'home'
        ? true
        : false
    }
  },
  created() {
    EventBus.on(
      Events.ADD_FILE_STORE_FILES_TO_SELECTION,
      this.addFileStoreFiles
    )
    EventBus.on(Events.FILES_TRASHED, this.removeFilesFromSelection)
  },
  mounted() {
    if (this.dialog) {
      this.openDialog(this.dialog)
    }

    if (this.addToCart) {
      console.log(this.addToCart)
    }

    if (this.rootStore.redirectAfterLogin) {
      EventBus.emit(Events.REQUEST_LOGIN)
    }

    if (this.rootStore.currentSection === '') {
      this.rootStore.setHome()
    }

    if (this.showBottomBar) {
      setTimeout(() => {
        this.showBottomBarDelayed = true
      }, 10)
    }
  },
  methods: {
    addFileStoreFiles(fileIds) {
      let idsToAd = [...fileIds]
      let showDoubleFilesWarning = false
      let selFiles = this.fileStoreStore.selectedFiles

      /*  this.rootStore.fileList.fileList.forEach((file) => {
        if (fileIds.indexOf(file.fileId) > -1) {
          idsToAd.splice(idsToAd.indexOf(file.fileId), 1)
          showDoubleFilesWarning = true
        }

      }) */

      for (let i = 0; i < selFiles.length; i++) {
        const file = selFiles[i]

        if (this.fileListStore.fileList.some((f) => f.fileName === file.name)) {
          idsToAd.splice(idsToAd.indexOf(file.fileId), 1)
          showDoubleFilesWarning = true
        }
      }

      selectFileStoreFiles(Cookies.get(UPLOAD_COOKIE), idsToAd)
      this.fileStoreStore.clearBrowserSelectedFileIds()

      if (showDoubleFilesWarning) {
        this.notificationDialog(
          '',
          `<p>Eén of meerdere van de door u geselecteerde bestanden kunnen niet worden toegevoegd aan de winkelwagen omdat deze al in de winkelwagen aanwezig zijn.</p>`,
          5000
        )
      }

      setTimeout(() => {
        this.fileListStore.getFiles()
      }, 500)
    },
    removeFilesFromSelection(fileIds) {
      let idsToRemove = []
      fileIds.forEach((fileId) => {
        const file = this.fileListStore.getFile(fileId)

        if (file) {
          idsToRemove.push(file.filename)
        }
      })
      this.fileListStore.removeFiles(idsToRemove)
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!from.name && to.name === 'home' && !to.query.dlg) {
        const adPrefs = vm.rootStore.theme.customFields.printStoreAd
        if (
          !adPrefs.hidePopUp &&
          vm.rootStore.preferences.showPrintStorePopUp
        ) {
          const select = adPrefs.onlyDefault
            ? 'DEFAULT_ONLY'
            : adPrefs.includeDefault
            ? 'INCLUDE_DEFAULT'
            : ''
          getRandomPrintStoreProducts(6, select).then((resp) => {
            vm.$modal.show(
              PrintStorePopUp,
              { products: resp },
              {
                width: 400,
                height: 'auto',
                adaptive: true
              }
            )
          })
        }
      }
    })
  },
  /*   beforeRouteUpdate(to, from, next) {
    if (to.name === 'home') {
      this.rootStore.setHome()
    } else {
      this.rootStore.globePlain()
    }
    next()
  }, */
  watch: {
    $route(to, from) {
      if (to.name === 'home') {
        this.rootStore.setHome()
      } else {
        this.rootStore.globePlain()
      }
    },
    showBottomBar(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.showBottomBarDelayed = true
        }, 10)
      } else {
        this.showBottomBarDelayed = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.werken-bij-rijnja {
  position: absolute;
  display: block;
  width: 156px;
  z-index: 9;
  color: white;
  background-color: #ea0029;
  animation: pulse 3s infinite;
  width: 156px;
  top: 80px;
  left: 15px;
}
.post-its {
  display: block;
  height: 250px;
  left: 0;
  margin: 0 auto;
  padding-left: 10px;
  position: fixed;
  right: 0;
  top: 112px;
  width: 320px;
  z-index: 9;
}

#home-wrapper {
  max-width: 1570px;
  width: 100%;
  margin: 0 auto;
  position: relative;

  &.printstore {
    max-width: 1570px;
  }
}

.ps-product-bar {
  background: white;
  top: calc(100vh - 212px);
  position: fixed;
  padding-top: 23px;
  overflow: hidden;
  left: calc(50% - 2982px);
  width: 5964px;
  height: 5964px;
  border-radius: 50%;

  /*  transition: top 0.5s ease-in-out;

  &.show {
    top: calc(100vh - 212px);
  } */
}

@media only screen and (max-height: 767px) {
  .ps-product-bar {
    display: none;
  }
}
@media only screen and (min-width: 768px) {
  .werken-bij-rijnja {
    display: block;
    top: 80px;
    right: 80px;
    left: unset;
  }
}

@media only screen and (min-width: 940px) {
  .werken-bij-rijnja {
    top: 100px;
    right: 100px;
  }
}

.slide-enter-from {
  top: 100vh;
}

.slide-enter-active {
  transition: top 0.5s ease 0.75s;
}

.slide-enter-to {
  top: calc(100vh - 212px);
}

.slide-leave-from {
  top: calc(100vh - 212px);
}

.slide-leave-active {
  transition: top 0.5s ease;
}

.slide-leave-to {
  top: 100vh;
}

@keyframes pulse {
  0% {
    box-shadow: #ea002940 0 0 0 0;
  }

  50% {
    //    color: rgba(var(--color), 0.5);

    box-shadow: #ea002995 0 0 15px 0;
  }

  100% {
    //color: rgba(234, 0, 41, 0);

    box-shadow: #ea002940 0 0 0px;
  }
}
</style>
